<template>
  <main :id="props.id">
    <h1 class="title-1 text-grey-900 pt-0 pt-lg-4">{{ props.title }}</h1>

    <div class="pt-2 layout">
      <slot></slot>
    </div>
  </main>
</template>

<script lang="ts" setup>
  // Vue
  import { defineProps } from 'vue'

  const props = defineProps({
    title: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
  })
</script>

<style scoped>
  .layout {
    max-width: 1296px;
    margin: 0 auto;
  }
</style>
